import { FC } from "react"
import BarCardComponentProps from "./bar_card_component_props"
import { Bar } from "react-chartjs-2";
import { getColorForDashboard } from "../../../../utils/general_utils";

const BarCardComponent: FC<BarCardComponentProps> = ({ data, title, chartLabel, yTitle, showXaxis = true, textAlign = 'start' }) => {
    const _parsedChartData = (): {
        labels: string[],
        datasets: {
            label: string,
            data: number[],
            backgroundColor: string[]
        }[]
    } => {
        const labels = data!.map(item => item.label);
        const backgroundColors = data!.map((_, index) => getColorForDashboard(index) + "aa"); // Generar un color diferente para cada barra
        const datasets = [{
            label: chartLabel ?? "",
            data: data!.map(day => day.value),
            backgroundColor: backgroundColors,
            fill: true,
        }];

        return {
            labels,
            datasets
        }
    }

    return <div className="bar_card_component">
        <h5 className="mb-3">{title}</h5>
        <Bar
            data={_parsedChartData()}
            options={{
                indexAxis: 'y', // Invertir las coordenadas al eje y
                plugins: {
                    legend: {
                        display: false,
                        position: 'left',
                    },
                },
                responsive: true,
                scales: {
                    y: {
                        ticks: {
                            callback: function(value: string | number, index: number) {
                                const label = this.getLabelForValue(index);
                                const maxLength = 12;
                                return label.length > maxLength ? label.slice(0, maxLength) + '…' : label;
                              },
                            crossAlign: 'near',
                            padding: 10,
                            font: {
                              size: 14,
                            },
                            align: textAlign ?? 'start',
                          }
                    }
                }
            }
            }
        />
    </div>
}

export default BarCardComponent